import React from "react";
import Loading from "../Loading/Loading";
import SmallBox from "../Box/SmallBox";
import AssetService from "../../services/AssetService";

class DashboardTotalAsset extends React.Component {

  assetService = new AssetService();

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.assetService.count().then(
        (data) => this.setState({totalAssets: data.total, loading: false})
    ).catch(
        () => this.setState({message: 'Falha ao carregar', loading: false})
    )
  }

  render() {
    const {loading} = this.props;
    if (loading) {
      return <Loading/>
    }
    let value = this.state.totalAssets;
    let message = 'Itens Gerados';

    if (this.state.message) {
      value = 0;
      message = this.state.message;
    }

    return (
        <SmallBox primary icon="tag">
          <h3>{value}</h3>
          <p>{message}</p>
        </SmallBox>
    );
  }
}

export default DashboardTotalAsset;
// withTracker(({}) => {
//   const subscription = Meteor.subscribe('asset.dashboard.total');
//   return {
//     loading: !subscription.ready(),
//     totalAssets: Counts.get('totalAssets'),
//   };
// })(DashboardTotalAsset);


// WEBPACK FOOTER //
// ./src/component/Asset/DashboardTotalAsset.js